import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./components/home/views/HomePage.vue'),
    },
    {
      path: '/ies/:ies_id',
      name: 'ies',
      component: () => import('./components/home/views/IesHolder.vue'),
    },
    {
      path: '/eje/:slug',
      name: 'Ejes',
      component: () => import('./components/home/views/AxisHolder.vue'),
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: () => import('./components/dashboard/DashboardHolder.vue'),
      children:[
        {
          path: 'login',
          name: 'Login',
          component: () => import('./components/dashboard/Login.vue')
        },
        {
          path: 'ies/:ies_id',
          name: 'IESHome',
          component: () => import('./components/dashboard/home/IesHome.vue')
        },
        {
          path: 'period_ies/:period_ies_id',
          name: 'PeriodIes',
          component: () => import('./components/dashboard/PeriodIes.vue')         
        },
        {
          path: 'ies_list/',
          name: 'ReviewerHome',
          component: () => import('./components/dashboard/home/ReviewerHome.vue')         
        },
      ]
    },
    {      
      path: "*",
      redirect: { name: 'home' },
    }
  ],
  scrollBehavior (to) {
    return { x: 0, y: 0 };
  }  
})
